import { LiveStream, ProgressStateModel, LiveStreamOperatorType, MatchTrackerType, LiveStreamDisciplineType } from 'eTip--common';
import { getEnv, SnapshotOut, types } from 'mobx-state-tree';
import { IMatchTrackerSelectionItem } from 'desktop--design-library';
import { ILiveApiSettings } from '../../liveAppEnvironment';

export enum MatchTrackerShowType {
    Default = "default", // default according to operator
    Stats = "stats" // stats for matchtracker };
}

export const MatchTrackerShowTypeForStore = types.enumeration('MatchTrackerShowTypeForStore', [MatchTrackerShowType.Default, MatchTrackerShowType.Stats]);


export const MatchTrackerRightSideWrapperStore = types
    .model("MatchTrackerRightSideWrapper", {
        showType: types.optional(MatchTrackerShowTypeForStore, MatchTrackerShowType.Default),
        matchTracker: types.maybeNull(LiveStream)
    }).actions((self) => {

        const env = getEnv<ILiveApiSettings>(self);
        const open = (streamData: IMatchTrackerSelectionItem): void => {
            const operator = streamData.type === MatchTrackerType.BRStage ? LiveStreamOperatorType.MatchTrackerBRStage : LiveStreamOperatorType.MatchTrackerBR;
            if (self.matchTracker) {

                self.matchTracker.setData({
                    operator: operator,
                    eventId: streamData.id,
                    externalId: streamData.matchId,
                    eventName: streamData.title,
                    eventDiscipline: LiveStreamDisciplineType.None,
                    eventCategoryPath: null,
                    eventStart: null,
                    graphicsPresentationId: streamData.graphicsPresentationId
                });
            } else {
                self.matchTracker = LiveStream.create(<SnapshotOut<typeof LiveStream>>{
                    state: ProgressStateModel.Loading,
                    operator: operator,
                    eventId: streamData.id,
                    externalId: streamData.matchId,
                    eventDiscipline: LiveStreamDisciplineType.None,
                    eventCategoryPath: null,
                    eventName: streamData.title,
                    graphicsPresentationId: streamData.graphicsPresentationId
                }, env);
            }
            self.matchTracker.prepareUrlsAsync(); //do not wait for result
        }

        const close = (): void => {
            if (self.matchTracker) {
                self.matchTracker.hide();
            }
            //self.matchTracker = null;
        }



        return {
            open,
            close
        }

    });
